/**
 * The owner's founder note, bio, photo and company line (owner-supplied 2026-10-29). Lives once here: the home
 * founder note (Task 7) and /about (Task 10A) both read it. No imports, so lib/seo can read COMPANY_LINE without a
 * cycle and a client file could take it safely.
 *
 * The photo files are git-ignored and R2-synced (public/site, scripts/assets-sync.sh), built by
 * scripts/site/founder-photo.mjs from the owner's own portrait; never a family photo.
 */

export const FOUNDER = {
  name: 'Saro Saravanan',
  role: 'Founder',
  heading: 'A note from our founder',
  /** Comp v5 text, verbatim. */
  note:
    "joonoo.art didn't start in a boardroom. It started with a toddler. I wanted to give my granddaughter a gift as magical as she is: a storybook where she wasn't reading about a hero, she was the hero. That summer project became joonoo.art. Every book we make starts the same way, with one family photo and the wish to see someone you love inside a story.",
  signOff: 'Saro Saravanan, founder',
  moreLabel: 'More about me and joonoo.art',
  moreHref: '/about',
  photo: {
    src: '/site/founder/saro-saravanan-640.webp',
    srcSmall: '/site/founder/saro-saravanan-320.webp',
    width: 640,
    height: 640, // square crop, as the comp's taped snapshot
    alt: 'Saro Saravanan, founder of joonoo.art',
  },
} as const;

/** Spec §6.1a blockquote, verbatim (owner-approved 2026-10-29). */
export const FOUNDER_BIO =
  "I built joonoo.art for my granddaughter before I built it for anyone else. For forty years my work has been building systems people trust with what matters most to them. At Fidelity Investments I was chief architect for NetBenefits, where millions of people manage their retirement savings. Later I led engineering for TSA PreCheck and the TSA CAT system that checks travellers' IDs at airport security, and I hold U.S. patents in identity verification. So your family's photo is handled the way I'd want my own family's handled: used only to make your book, kept private, and deleted automatically.";

export const FOUNDER_LINKEDIN = 'https://www.linkedin.com/in/saro-saravanan-a0978/';

export const COMPANY_LINE = 'joonoo.art is operated by Verby, LLC, a Delaware technology company';
